import { render, staticRenderFns } from "./GroupDocSettingTable.vue?vue&type=template&id=3b7e2229&"
import script from "./GroupDocSettingTable.vue?vue&type=script&lang=js&"
export * from "./GroupDocSettingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports